var _ellipse, _path, _path2, _path3, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChooseTaxGroup = function SvgChooseTaxGroup(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 92,
    rx: 39,
    ry: 2,
    fill: "url(#paint0_linear_1463_29284)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.3684C14.5 10.0898 19.5898 5 25.8684 5H74.184V72.159C74.184 78.2272 67.5448 81.9584 62.3613 78.8033C59.6339 77.1432 56.1691 77.3183 53.6231 79.245L51.5574 80.8082C47.4995 83.8791 41.895 83.8791 37.8371 80.8082L35.911 79.3507C33.2717 77.3533 29.6904 77.1387 26.8313 78.8064C21.3649 81.9952 14.5 78.0522 14.5 71.7237V16.3684Z",
    fill: "url(#paint1_linear_1463_29284)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1841 5H81.2893C84.4286 5 86.9735 7.5449 86.9735 10.6842V39.1051C86.9735 42.2444 84.4286 44.7893 81.2893 44.7893H74.1841V5Z",
    fill: "url(#paint2_linear_1463_29284)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4472 5C76.1735 5 74.6578 7.8421 74.1841 9.26314V5H78.4472Z",
    fill: "#E5F4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.787,
    cy: 26.4911,
    r: 1.78213,
    fill: "#B2DAFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.787,
    cy: 37.1825,
    r: 1.78213,
    fill: "#B2DAFB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.787,
    cy: 47.8759,
    r: 1.78213,
    fill: "#B2DAFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.9453,
    y: 24.709,
    width: 33.2665,
    height: 3.56427,
    rx: 1.78213,
    fill: "#B2DAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9453,
    y: 35.4023,
    width: 21.3856,
    height: 3.56427,
    rx: 1.78213,
    fill: "#B2DAFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 62,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#B2DAFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9453,
    y: 46.0938,
    width: 33.2665,
    height: 3.56427,
    rx: 1.78213,
    fill: "#B2DAFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1463_29284",
    x1: 8.8,
    y1: 92.8,
    x2: 80.2613,
    y2: 90.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1463_29284",
    x1: -84.3102,
    y1: 76.0524,
    x2: 112.937,
    y2: -25.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560479,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1463_29284",
    x1: 71.8587,
    y1: 27.5473,
    x2: 127.712,
    y2: 42.2189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560479,
    stopColor: "#E4F3FE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChooseTaxGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "choose-tax-group.b580b5dc48c9eeff41f193893e9669fb.svg";